import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Col from '@minecraft.col';

export const LoginLoader: FC = () => {
  return (
    <>
      <Col sm="12" md="3">
        <Skeleton width="50%" height="40px" className="cn_mb-4 cn_mt-8" />
        <Skeleton width="100%" height="40px" className="cn_mb-4" />
        <Skeleton width="100%" height="40px" className="cn_mb-4" />

        <Skeleton width="50%" height="22px" className="cn_mb-2" />
        <Skeleton width="100%" height="40px" className="cn_mb-4" />

        <Skeleton width="50%" height="22px" className="cn_mb-2" />
        <Skeleton width="100%" height="40px" className="cn_mb-4" />

        <Skeleton width="60%" height="22px" className="cn_mb-2" />
        <Skeleton width="100%" height="40px" className="cn_mb-4" />

        <Skeleton width="100%" height="40px" className="cn_mb-2" />
      </Col>
    </>
  );
};
